import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../app/stores/store';
import LoadingComponent from '../../../../app/layout/LoadingComponent';
import DynamicTableComponent from '../../../DynamicTable/DynamicTableComponent';
import _ from 'lodash';

// // css
// const fullViewTableCSS = {
//   Responsive: true,
//   marginTop: "6em",
//   padding: "10px",
//   marginLeft: "1em",
//   marginBottom: "1em",
//   height: "675px",
// }

function HistoryTable() {
  const { dashboardStore, activityStore } = useStore();
  const { historyData } = activityStore || {};
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    if (id) {
      activityStore.historyPageNumber = 1;
      activityStore.viewHistorySearch(
        id,
        JSON.stringify(dashboardStore.dashboard.searchfilterparams)?.length !==
          2
          ? JSON.stringify(dashboardStore.dashboard.searchfilterparams)
          : '',
        1,
        5,
      );
    }
    // eslint-disable-next-line
  }, [id]);

  const paginateFunction = (e: number) => {
    //search filter params (search some)
    //1) Pagination + Search
    activityStore.historyPageNumber = e;
    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      activityStore.viewHistorySearch(
        id || '',
        JSON.stringify(dashboardStore.dashboard.searchfilterparams),
        e,
        5,
      );
    }
    //pagination + Sort -> OrderData(Ascending or Descending) Order Name (Title or langugage or year)
    else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      let params = {
        itemid: id || '',
        sortvalue: dashboardStore.dashboard.orderName || '',
        sortby: dashboardStore.dashboard.orderData,
        PageNumber: e,
        PageSize: 5,
      };
      activityStore.viewHistorySort(params);
    }
    //only Pagination without Search or Sort
    else {
      activityStore.viewHistorySearch(id || '', '', e, 5);
    }
    //Setting the pagenumber to dashboardStore so we can have track of page even after rerender
    // dashboardStore.setCRTablePageNumFunc(e);
    //Setting the page number in state
  };

  const removeCol = 'taskId,appUserId,photos,files,subTaskId';
  const VaultTable: any = JSON?.parse(JSON?.stringify(historyData));
  VaultTable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  return (
    <Segment clearing responsive={true}>
      <Header
        icon="list"
        size="huge"
        dividing
        as="h1"
        content="View History"
        sub
        color="grey"
      />
      {activityStore.isViewHistoryLoading ? (
        <LoadingComponent />
      ) : (
        <DynamicTableComponent
          data={historyData}
          name={'viewHistoryTable'}
          actiontype={''}
          pageFunc={paginateFunction}
          pageNumData={activityStore.historyPageNumber}
          searchFuncData={() => {}}
        />
      )}
    </Segment>
  );
}

export default observer(HistoryTable);
